import { render, staticRenderFns } from "./review-modal.vue?vue&type=template&id=4414447c&scoped=true&"
import script from "./review-modal.vue?vue&type=script&lang=js&"
export * from "./review-modal.vue?vue&type=script&lang=js&"
import style0 from "./review-modal.vue?vue&type=style&index=0&id=4414447c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4414447c",
  null
  
)

export default component.exports